import { createRequestActionTypes } from "../../../../utils/request-actions-helpers/createRequestActionTypes";
import { ApiConfig } from "../../../../config/ApiConfig";
import { FetchRequestActions } from "../../../../utils/request-actions-helpers/createRequestActions";
import { RequestThunkParameters, createRequestThunk } from "../../../../utils/request-actions-helpers/createRequestThunk";
import { Document } from "../../../../models";

export const deleteDocumentActionTypes = createRequestActionTypes('DELETE_DOCUMENT')

export interface DeleteDocumentActionParameters {
    docId: string
}

export interface DeleteDocumentResponse {

}

export type DeleteDocumentActions = FetchRequestActions<DeleteDocumentResponse, DeleteDocumentActionParameters>

export const deleteDocument = (config: ApiConfig, docId: string) => {
    const thunkParams: RequestThunkParameters<DeleteDocumentResponse, never, DeleteDocumentActionParameters> = {
        method: 'DELETE',
        requestActionTypes: deleteDocumentActionTypes,
        url: `${config.API_URL}/archive?id=${docId}`,
        actionAdditionalData: {
            docId
        },
        processResultBeforeDispatch: (result: DeleteDocumentResponse) => {
            if (config.refreshFeed) {
                config.refreshFeed()
            }
            if (config.updateItem) {
                config.updateItem(docId)
            }
            return result
        }
    }
    return createRequestThunk(thunkParams)
}